import React from 'react'

import { Link } from 'gatsby'

import { Cart, MobileSearch } from '../index'

import { StyledMenu } from './MobileNavMenu.styled'
import styles from './MobileNavMenu.module.sass'

const MobileNavMenu = ({ open }) => {
  return (
    <StyledMenu className={styles.mobileMenu} open={open}>
      <MobileSearch />
      <Link exact to="/" activeClassName="activeNavLink">
        Home
      </Link>
      <Link exact to="/shop" activeClassName="activeNavLink">
        Shop
      </Link>
      <Link exact to="/about" activeClassName="activeNavLink">
        About Us
      </Link>
      <Link exact to="/contact" activeClassName="activeNavLink">
        Contact
      </Link>
      <button className="snipcart-checkout" aria-label="go to checkout">
        <Cart />
      </button>
    </StyledMenu>
  )
}
export default MobileNavMenu
